import {
  AuthRepository,
  SessionRepository,
  TwoFactorRepository,
  SecurityRepository,
  TokenServiceImpl,
  StorageServiceImpl,
} from '../repositories';

import {
  LoginUseCase,
  LogoutUseCase,
  Verify2FAUseCase,
  RefreshTokenUseCase,
  GetProfileUseCase,
  UpdateProfileUseCase,
  ChangePasswordUseCase,
  ChangeEmailUseCase,
  VerifyEmailChangeUseCase,
  DeleteAccountUseCase,
  Activate2FAUseCase,
  Deactivate2FAUseCase,
  VerifyBackupCodeUseCase,
  ListSessionsUseCase,
  RevokeSessionUseCase,
  RevokeAllSessionsUseCase,
  RequestPasswordResetUseCase,
  ResetPasswordUseCase,
} from '../../application/use-cases';

// Singletons des implementations infrastructure
const authRepository = new AuthRepository();
const sessionRepository = new SessionRepository();
const twoFactorRepository = new TwoFactorRepository();
const securityRepository = new SecurityRepository();
const tokenService = new TokenServiceImpl();
const storageService = new StorageServiceImpl();

/**
 * Conteneur d'injection de dependances.
 * Instancie les use cases avec leurs dependances.
 */
export const container = {
  // Auth
  loginUseCase: new LoginUseCase(authRepository, tokenService, storageService),
  logoutUseCase: new LogoutUseCase(authRepository, tokenService, storageService),
  verify2FAUseCase: new Verify2FAUseCase(authRepository, tokenService, storageService),
  refreshTokenUseCase: new RefreshTokenUseCase(authRepository, tokenService),

  // Profile
  getProfileUseCase: new GetProfileUseCase(authRepository, storageService),
  updateProfileUseCase: new UpdateProfileUseCase(authRepository, storageService),
  changePasswordUseCase: new ChangePasswordUseCase(authRepository),
  changeEmailUseCase: new ChangeEmailUseCase(authRepository),
  verifyEmailChangeUseCase: new VerifyEmailChangeUseCase(authRepository),
  deleteAccountUseCase: new DeleteAccountUseCase(authRepository, tokenService, storageService),

  // Two-Factor
  activate2FAUseCase: new Activate2FAUseCase(twoFactorRepository),
  deactivate2FAUseCase: new Deactivate2FAUseCase(twoFactorRepository),
  verifyBackupCodeUseCase: new VerifyBackupCodeUseCase(twoFactorRepository),

  // Sessions
  listSessionsUseCase: new ListSessionsUseCase(sessionRepository),
  revokeSessionUseCase: new RevokeSessionUseCase(sessionRepository),
  revokeAllSessionsUseCase: new RevokeAllSessionsUseCase(sessionRepository),

  // Password
  requestPasswordResetUseCase: new RequestPasswordResetUseCase(securityRepository),
  resetPasswordUseCase: new ResetPasswordUseCase(securityRepository),
} as const;

export type Container = typeof container;
